import Vue from 'vue'
import * as types from 'store/mutation-types'

const state = {
  updates: {},
  readUpdates: [],
  tips: [
    {
      url: 'https://player.hotmart.com/embed/nx9pox',
      duration: '1 minuto',
      title: 'Como criar sua Página de pagamentos'
    },
    {
      url: 'https://player.hotmart.com/embed/n998rz',
      duration: '1 minuto',
      title: 'Como criar sua Página de pagamentos para Celular'
    },
    {
      url: 'https://player.hotmart.com/embed/nvq8p5',
      duration: '1 minuto',
      title: 'Como dar um up nas suas vendas através da Página de pagamentos'
    }
  ]
}

const getters = {
  updatesCount ({ readUpdates, updates }) {
    const updateIds = Object.keys(updates)
    let counter = 0

    updateIds.forEach(id => {
      if (!readUpdates.includes(id)) {
        counter++
      }
    })

    return counter
  },
  isUnread: ({ readUpdates }) => id => {
    return !readUpdates.includes(id)
  }
}

const mutations = {
  [types.SET_UPDATES] (state, documents) {
    state.updates = {}
    documents.forEach(doc => {
      Vue.set(state.updates, doc.id, doc.data())
    })
  },
  [types.SET_READ_UPDATES] (state, ids) {
    state.readUpdates = ids
  }
}

export default {
  state,
  getters,
  mutations,
  namespaced: true
}
